function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        width: 100%;\n        outline: none;\n        background: #fff;\n      }\n\n      [part=\"overlay-header\"] {\n        display: flex;\n        flex-shrink: 0;\n        flex-wrap: nowrap;\n        align-items: center;\n      }\n\n      :host(:not([fullscreen])) [part=\"overlay-header\"] {\n        display: none;\n      }\n\n      [part=\"label\"] {\n        flex-grow: 1;\n      }\n\n      [part=\"clear-button\"]:not([showclear]) {\n        display: none;\n      }\n\n      [part=\"years-toggle-button\"] {\n        display: flex;\n      }\n\n      [part=\"years-toggle-button\"][desktop] {\n        display: none;\n      }\n\n      :host(:not([years-visible])) [part=\"years-toggle-button\"]::before {\n        transform: rotate(180deg);\n      }\n\n      #scrollers {\n        display: flex;\n        height: 100%;\n        width: 100%;\n        position: relative;\n        overflow: hidden;\n      }\n\n      [part=\"months\"],\n      [part=\"years\"] {\n        height: 100%;\n      }\n\n      [part=\"months\"] {\n        --vaadin-infinite-scroller-item-height: 270px;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n      }\n\n      #scrollers[desktop] [part=\"months\"] {\n        right: 50px;\n        transform: none !important;\n      }\n\n      [part=\"years\"] {\n        --vaadin-infinite-scroller-item-height: 80px;\n        width: 50px;\n        position: absolute;\n        right: 0;\n        transform: translateX(100%);\n        -webkit-tap-highlight-color: transparent;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        /* Center the year scroller position. */\n        --vaadin-infinite-scroller-buffer-offset: 50%;\n      }\n\n      #scrollers[desktop] [part=\"years\"] {\n        position: absolute;\n        transform: none !important;\n      }\n\n      [part=\"years\"]::before {\n        content: '';\n        display: block;\n        background: transparent;\n        width: 0;\n        height: 0;\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        border-width: 6px;\n        border-style: solid;\n        border-color: transparent;\n        border-left-color: #000;\n      }\n\n      :host(.animate) [part=\"months\"],\n      :host(.animate) [part=\"years\"] {\n        transition: all 200ms;\n      }\n\n      [part=\"toolbar\"] {\n        display: flex;\n        justify-content: space-between;\n        z-index: 2;\n        flex-shrink: 0;\n      }\n\n      [part~=\"overlay-header\"]:not([desktop]) {\n        padding-bottom: 40px;\n      }\n\n      [part~=\"years-toggle-button\"] {\n        position: absolute;\n        top: auto;\n        right: 8px;\n        bottom: 0;\n        z-index: 1;\n        padding: 8px;\n      }\n\n      #announcer {\n        display: inline-block;\n        position: fixed;\n        clip: rect(0, 0, 0, 0);\n        clip-path: inset(100%);\n      }\n    </style>\n\n    <div id=\"announcer\" role=\"alert\" aria-live=\"polite\">\n      [[i18n.calendar]]\n    </div>\n\n    <div part=\"overlay-header\" on-touchend=\"_preventDefault\" desktop$=\"[[_desktopMode]]\" aria-hidden=\"true\">\n      <div part=\"label\">[[_formatDisplayed(selectedDate, i18n.formatDate, label)]]</div>\n      <div part=\"clear-button\" on-tap=\"_clear\" showclear$=\"[[_showClear(selectedDate)]]\"></div>\n      <div part=\"toggle-button\" on-tap=\"_cancel\"></div>\n\n      <div part=\"years-toggle-button\" desktop$=\"[[_desktopMode]]\" on-tap=\"_toggleYearScroller\" aria-hidden=\"true\">\n        [[_yearAfterXMonths(_visibleMonthIndex)]]\n      </div>\n    </div>\n\n    <div id=\"scrollers\" desktop$=\"[[_desktopMode]]\" on-track=\"_track\">\n      <vaadin-infinite-scroller id=\"monthScroller\" on-custom-scroll=\"_onMonthScroll\" on-touchstart=\"_onMonthScrollTouchStart\" buffer-size=\"3\" active=\"[[initialPosition]]\" part=\"months\">\n        <template>\n          <vaadin-month-calendar i18n=\"[[i18n]]\" month=\"[[_dateAfterXMonths(index)]]\" selected-date=\"{{selectedDate}}\" focused-date=\"[[focusedDate]]\" ignore-taps=\"[[_ignoreTaps]]\" show-week-numbers=\"[[showWeekNumbers]]\" min-date=\"[[minDate]]\" max-date=\"[[maxDate]]\" focused$=\"[[_focused]]\" part=\"month\" theme$=\"[[theme]]\">\n          </vaadin-month-calendar>\n        </template>\n      </vaadin-infinite-scroller>\n      <vaadin-infinite-scroller id=\"yearScroller\" on-tap=\"_onYearTap\" on-custom-scroll=\"_onYearScroll\" on-touchstart=\"_onYearScrollTouchStart\" buffer-size=\"12\" active=\"[[initialPosition]]\" part=\"years\">\n        <template>\n          <div part=\"year-number\" role=\"button\" current$=\"[[_isCurrentYear(index)]]\" selected$=\"[[_isSelectedYear(index, selectedDate)]]\">\n            [[_yearAfterXYears(index)]]\n          </div>\n          <div part=\"year-separator\" aria-hidden=\"true\"></div>\n        </template>\n      </vaadin-infinite-scroller>\n    </div>\n\n    <div on-touchend=\"_preventDefault\" role=\"toolbar\" part=\"toolbar\">\n      <vaadin-button id=\"todayButton\" part=\"today-button\" disabled=\"[[!_isTodayAllowed(minDate, maxDate)]]\" on-tap=\"_onTodayTap\">\n        [[i18n.today]]\n      </vaadin-button>\n      <vaadin-button id=\"cancelButton\" part=\"cancel-button\" on-tap=\"_cancel\">\n        [[i18n.cancel]]\n      </vaadin-button>\n    </div>\n\n    <iron-media-query query=\"(min-width: 375px)\" query-matches=\"{{_desktopMode}}\"></iron-media-query>\n"], ["\n    <style>\n      :host {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        width: 100%;\n        outline: none;\n        background: #fff;\n      }\n\n      [part=\"overlay-header\"] {\n        display: flex;\n        flex-shrink: 0;\n        flex-wrap: nowrap;\n        align-items: center;\n      }\n\n      :host(:not([fullscreen])) [part=\"overlay-header\"] {\n        display: none;\n      }\n\n      [part=\"label\"] {\n        flex-grow: 1;\n      }\n\n      [part=\"clear-button\"]:not([showclear]) {\n        display: none;\n      }\n\n      [part=\"years-toggle-button\"] {\n        display: flex;\n      }\n\n      [part=\"years-toggle-button\"][desktop] {\n        display: none;\n      }\n\n      :host(:not([years-visible])) [part=\"years-toggle-button\"]::before {\n        transform: rotate(180deg);\n      }\n\n      #scrollers {\n        display: flex;\n        height: 100%;\n        width: 100%;\n        position: relative;\n        overflow: hidden;\n      }\n\n      [part=\"months\"],\n      [part=\"years\"] {\n        height: 100%;\n      }\n\n      [part=\"months\"] {\n        --vaadin-infinite-scroller-item-height: 270px;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n      }\n\n      #scrollers[desktop] [part=\"months\"] {\n        right: 50px;\n        transform: none !important;\n      }\n\n      [part=\"years\"] {\n        --vaadin-infinite-scroller-item-height: 80px;\n        width: 50px;\n        position: absolute;\n        right: 0;\n        transform: translateX(100%);\n        -webkit-tap-highlight-color: transparent;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        /* Center the year scroller position. */\n        --vaadin-infinite-scroller-buffer-offset: 50%;\n      }\n\n      #scrollers[desktop] [part=\"years\"] {\n        position: absolute;\n        transform: none !important;\n      }\n\n      [part=\"years\"]::before {\n        content: '';\n        display: block;\n        background: transparent;\n        width: 0;\n        height: 0;\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        border-width: 6px;\n        border-style: solid;\n        border-color: transparent;\n        border-left-color: #000;\n      }\n\n      :host(.animate) [part=\"months\"],\n      :host(.animate) [part=\"years\"] {\n        transition: all 200ms;\n      }\n\n      [part=\"toolbar\"] {\n        display: flex;\n        justify-content: space-between;\n        z-index: 2;\n        flex-shrink: 0;\n      }\n\n      [part~=\"overlay-header\"]:not([desktop]) {\n        padding-bottom: 40px;\n      }\n\n      [part~=\"years-toggle-button\"] {\n        position: absolute;\n        top: auto;\n        right: 8px;\n        bottom: 0;\n        z-index: 1;\n        padding: 8px;\n      }\n\n      #announcer {\n        display: inline-block;\n        position: fixed;\n        clip: rect(0, 0, 0, 0);\n        clip-path: inset(100%);\n      }\n    </style>\n\n    <div id=\"announcer\" role=\"alert\" aria-live=\"polite\">\n      [[i18n.calendar]]\n    </div>\n\n    <div part=\"overlay-header\" on-touchend=\"_preventDefault\" desktop\\$=\"[[_desktopMode]]\" aria-hidden=\"true\">\n      <div part=\"label\">[[_formatDisplayed(selectedDate, i18n.formatDate, label)]]</div>\n      <div part=\"clear-button\" on-tap=\"_clear\" showclear\\$=\"[[_showClear(selectedDate)]]\"></div>\n      <div part=\"toggle-button\" on-tap=\"_cancel\"></div>\n\n      <div part=\"years-toggle-button\" desktop\\$=\"[[_desktopMode]]\" on-tap=\"_toggleYearScroller\" aria-hidden=\"true\">\n        [[_yearAfterXMonths(_visibleMonthIndex)]]\n      </div>\n    </div>\n\n    <div id=\"scrollers\" desktop\\$=\"[[_desktopMode]]\" on-track=\"_track\">\n      <vaadin-infinite-scroller id=\"monthScroller\" on-custom-scroll=\"_onMonthScroll\" on-touchstart=\"_onMonthScrollTouchStart\" buffer-size=\"3\" active=\"[[initialPosition]]\" part=\"months\">\n        <template>\n          <vaadin-month-calendar i18n=\"[[i18n]]\" month=\"[[_dateAfterXMonths(index)]]\" selected-date=\"{{selectedDate}}\" focused-date=\"[[focusedDate]]\" ignore-taps=\"[[_ignoreTaps]]\" show-week-numbers=\"[[showWeekNumbers]]\" min-date=\"[[minDate]]\" max-date=\"[[maxDate]]\" focused\\$=\"[[_focused]]\" part=\"month\" theme\\$=\"[[theme]]\">\n          </vaadin-month-calendar>\n        </template>\n      </vaadin-infinite-scroller>\n      <vaadin-infinite-scroller id=\"yearScroller\" on-tap=\"_onYearTap\" on-custom-scroll=\"_onYearScroll\" on-touchstart=\"_onYearScrollTouchStart\" buffer-size=\"12\" active=\"[[initialPosition]]\" part=\"years\">\n        <template>\n          <div part=\"year-number\" role=\"button\" current\\$=\"[[_isCurrentYear(index)]]\" selected\\$=\"[[_isSelectedYear(index, selectedDate)]]\">\n            [[_yearAfterXYears(index)]]\n          </div>\n          <div part=\"year-separator\" aria-hidden=\"true\"></div>\n        </template>\n      </vaadin-infinite-scroller>\n    </div>\n\n    <div on-touchend=\"_preventDefault\" role=\"toolbar\" part=\"toolbar\">\n      <vaadin-button id=\"todayButton\" part=\"today-button\" disabled=\"[[!_isTodayAllowed(minDate, maxDate)]]\" on-tap=\"_onTodayTap\">\n        [[i18n.today]]\n      </vaadin-button>\n      <vaadin-button id=\"cancelButton\" part=\"cancel-button\" on-tap=\"_cancel\">\n        [[i18n.cancel]]\n      </vaadin-button>\n    </div>\n\n    <iron-media-query query=\"(min-width: 375px)\" query-matches=\"{{_desktopMode}}\"></iron-media-query>\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { GestureEventListeners } from '@polymer/polymer/lib/mixins/gesture-event-listeners.js';
import '@polymer/iron-media-query/iron-media-query.js';
import { IronA11yKeysBehavior } from '@polymer/iron-a11y-keys-behavior/iron-a11y-keys-behavior.js';
import { IronA11yAnnouncer } from '@polymer/iron-a11y-announcer/iron-a11y-announcer.js';
import '@vaadin/vaadin-button/src/vaadin-button.js';
import { ThemableMixin } from '@vaadin/vaadin-themable-mixin/vaadin-themable-mixin.js';
import { ThemePropertyMixin } from '@vaadin/vaadin-themable-mixin/vaadin-theme-property-mixin.js';
import './vaadin-month-calendar.js';
import './vaadin-infinite-scroller.js';
import { DatePickerHelper } from './vaadin-date-picker-helper.js';
import './vaadin-date-picker-styles.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { addListener, setTouchAction } from '@polymer/polymer/lib/utils/gestures.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
/**
 * @memberof Vaadin
 * @private
 */

var DatePickerOverlayContentElement = /*#__PURE__*/function (_ThemableMixin) {
  _inherits(DatePickerOverlayContentElement, _ThemableMixin);

  var _super = _createSuper(DatePickerOverlayContentElement);

  function DatePickerOverlayContentElement() {
    _classCallCheck(this, DatePickerOverlayContentElement);

    return _super.apply(this, arguments);
  }

  _createClass(DatePickerOverlayContentElement, [{
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(DatePickerOverlayContentElement.prototype), "ready", this).call(this);

      this.setAttribute('tabindex', 0);
      this.addEventListener('keydown', this._onKeydown.bind(this));
      addListener(this, 'tap', this._stopPropagation);
      this.addEventListener('focus', this._onOverlayFocus.bind(this));
      this.addEventListener('blur', this._onOverlayBlur.bind(this));
    }
    /**
     * Fired when the scroller reaches the target scrolling position.
     * @event scroll-animation-finished
     * @param {Number} detail.position new position
     * @param {Number} detail.oldPosition old position
     */

  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(DatePickerOverlayContentElement.prototype), "connectedCallback", this).call(this);

      this._closeYearScroller();

      this._toggleAnimateClass(true);

      setTouchAction(this.$.scrollers, 'pan-y');
      IronA11yAnnouncer.requestAvailability();
    }
  }, {
    key: "announceFocusedDate",
    value: function announceFocusedDate() {
      var focusedDate = this._currentlyFocusedDate();

      var announce = [];

      if (DatePickerHelper._dateEquals(focusedDate, new Date())) {
        announce.push(this.i18n.today);
      }

      announce = announce.concat([this.i18n.weekdays[focusedDate.getDay()], focusedDate.getDate(), this.i18n.monthNames[focusedDate.getMonth()], focusedDate.getFullYear()]);

      if (this.showWeekNumbers && this.i18n.firstDayOfWeek === 1) {
        announce.push(this.i18n.week);
        announce.push(DatePickerHelper._getISOWeekNumber(focusedDate));
      }

      this.dispatchEvent(new CustomEvent('iron-announce', {
        bubbles: true,
        composed: true,
        detail: {
          text: announce.join(' ')
        }
      }));
      return;
    }
    /**
     * Focuses the cancel button
     */

  }, {
    key: "focusCancel",
    value: function focusCancel() {
      this.$.cancelButton.focus();
    }
    /**
     * Scrolls the list to the given Date.
     */

  }, {
    key: "scrollToDate",
    value: function scrollToDate(date, animate) {
      this._scrollToPosition(this._differenceInMonths(date, this._originDate), animate);
    }
  }, {
    key: "_focusedDateChanged",
    value: function _focusedDateChanged(focusedDate) {
      this.revealDate(focusedDate);
    }
  }, {
    key: "_isCurrentYear",
    value: function _isCurrentYear(yearsFromNow) {
      return yearsFromNow === 0;
    }
  }, {
    key: "_isSelectedYear",
    value: function _isSelectedYear(yearsFromNow, selectedDate) {
      if (selectedDate) {
        return selectedDate.getFullYear() === this._originDate.getFullYear() + yearsFromNow;
      }
    }
    /**
     * Scrolls the month and year scrollers enough to reveal the given date.
     */

  }, {
    key: "revealDate",
    value: function revealDate(date) {
      if (date) {
        var diff = this._differenceInMonths(date, this._originDate);

        var scrolledAboveViewport = this.$.monthScroller.position > diff;
        var visibleItems = this.$.monthScroller.clientHeight / this.$.monthScroller.itemHeight;
        var scrolledBelowViewport = this.$.monthScroller.position + visibleItems - 1 < diff;

        if (scrolledAboveViewport) {
          this._scrollToPosition(diff, true);
        } else if (scrolledBelowViewport) {
          this._scrollToPosition(diff - visibleItems + 1, true);
        }
      }
    }
  }, {
    key: "_onOverlayFocus",
    value: function _onOverlayFocus() {
      this._focused = true;
    }
  }, {
    key: "_onOverlayBlur",
    value: function _onOverlayBlur() {
      this._focused = false;
    }
  }, {
    key: "_initialPositionChanged",
    value: function _initialPositionChanged(initialPosition) {
      this.scrollToDate(initialPosition);
    }
  }, {
    key: "_repositionYearScroller",
    value: function _repositionYearScroller() {
      this._visibleMonthIndex = Math.floor(this.$.monthScroller.position);
      this.$.yearScroller.position = (this.$.monthScroller.position + this._originDate.getMonth()) / 12;
    }
  }, {
    key: "_repositionMonthScroller",
    value: function _repositionMonthScroller() {
      this.$.monthScroller.position = this.$.yearScroller.position * 12 - this._originDate.getMonth();
      this._visibleMonthIndex = Math.floor(this.$.monthScroller.position);
    }
  }, {
    key: "_onMonthScroll",
    value: function _onMonthScroll() {
      this._repositionYearScroller();

      this._doIgnoreTaps();
    }
  }, {
    key: "_onYearScroll",
    value: function _onYearScroll() {
      this._repositionMonthScroller();

      this._doIgnoreTaps();
    }
  }, {
    key: "_onYearScrollTouchStart",
    value: function _onYearScrollTouchStart() {
      var _this = this;

      this._notTapping = false;
      setTimeout(function () {
        return _this._notTapping = true;
      }, 300);

      this._repositionMonthScroller();
    }
  }, {
    key: "_onMonthScrollTouchStart",
    value: function _onMonthScrollTouchStart() {
      this._repositionYearScroller();
    }
  }, {
    key: "_doIgnoreTaps",
    value: function _doIgnoreTaps() {
      var _this2 = this;

      this._ignoreTaps = true;
      this._debouncer = Debouncer.debounce(this._debouncer, timeOut.after(300), function () {
        return _this2._ignoreTaps = false;
      });
    }
  }, {
    key: "_formatDisplayed",
    value: function _formatDisplayed(date, formatDate, label) {
      if (date) {
        return formatDate(DatePickerHelper._extractDateParts(date));
      } else {
        return label;
      }
    }
  }, {
    key: "_onTodayTap",
    value: function _onTodayTap() {
      var today = new Date();

      if (Math.abs(this.$.monthScroller.position - this._differenceInMonths(today, this._originDate)) < 0.001) {
        // Select today only if the month scroller is positioned approximately
        // at the beginning of the current month
        this.selectedDate = today;

        this._close();
      } else {
        this._scrollToCurrentMonth();
      }
    }
  }, {
    key: "_scrollToCurrentMonth",
    value: function _scrollToCurrentMonth() {
      if (this.focusedDate) {
        this.focusedDate = new Date();
      }

      this.scrollToDate(new Date(), true);
    }
  }, {
    key: "_showClear",
    value: function _showClear(selectedDate) {
      return !!selectedDate;
    }
  }, {
    key: "_onYearTap",
    value: function _onYearTap(e) {
      if (!this._ignoreTaps && !this._notTapping) {
        var scrollDelta = e.detail.y - (this.$.yearScroller.getBoundingClientRect().top + this.$.yearScroller.clientHeight / 2);
        var yearDelta = scrollDelta / this.$.yearScroller.itemHeight;

        this._scrollToPosition(this.$.monthScroller.position + yearDelta * 12, true);
      }
    }
  }, {
    key: "_scrollToPosition",
    value: function _scrollToPosition(targetPosition, animate) {
      var _this3 = this;

      if (this._targetPosition !== undefined) {
        this._targetPosition = targetPosition;
        return;
      }

      if (!animate) {
        this.$.monthScroller.position = targetPosition;
        this._targetPosition = undefined;

        this._repositionYearScroller();

        return;
      }

      this._targetPosition = targetPosition; // http://gizma.com/easing/

      var easingFunction = function easingFunction(t, b, c, d) {
        t /= d / 2;

        if (t < 1) {
          return c / 2 * t * t + b;
        }

        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };

      var duration = animate ? 300 : 0;
      var start = 0;
      var initialPosition = this.$.monthScroller.position;

      var smoothScroll = function smoothScroll(timestamp) {
        start = start || timestamp;
        var currentTime = timestamp - start;

        if (currentTime < duration) {
          var currentPos = easingFunction(currentTime, initialPosition, _this3._targetPosition - initialPosition, duration);
          _this3.$.monthScroller.position = currentPos;
          window.requestAnimationFrame(smoothScroll);
        } else {
          _this3.dispatchEvent(new CustomEvent('scroll-animation-finished', {
            bubbles: true,
            composed: true,
            detail: {
              position: _this3._targetPosition,
              oldPosition: initialPosition
            }
          }));

          _this3.$.monthScroller.position = _this3._targetPosition;
          _this3._targetPosition = undefined;
        }

        setTimeout(_this3._repositionYearScroller.bind(_this3), 1);
      }; // Start the animation.


      window.requestAnimationFrame(smoothScroll);
    }
  }, {
    key: "_limit",
    value: function _limit(value, range) {
      return Math.min(range.max, Math.max(range.min, value));
    }
  }, {
    key: "_handleTrack",
    value: function _handleTrack(e) {
      // Check if horizontal movement threshold (dx) not exceeded or
      // scrolling fast vertically (ddy).
      if (Math.abs(e.detail.dx) < 10 || Math.abs(e.detail.ddy) > 10) {
        return;
      } // If we're flinging quickly -> start animating already.


      if (Math.abs(e.detail.ddx) > this._yearScrollerWidth / 3) {
        this._toggleAnimateClass(true);
      }

      var newTranslateX = this._translateX + e.detail.ddx;
      this._translateX = this._limit(newTranslateX, {
        min: 0,
        max: this._yearScrollerWidth
      });
    }
  }, {
    key: "_track",
    value: function _track(e) {
      if (this._desktopMode) {
        // No need to track for swipe gestures on desktop.
        return;
      }

      switch (e.detail.state) {
        case 'start':
          this._toggleAnimateClass(false);

          break;

        case 'track':
          this._handleTrack(e);

          break;

        case 'end':
          this._toggleAnimateClass(true);

          if (this._translateX >= this._yearScrollerWidth / 2) {
            this._closeYearScroller();
          } else {
            this._openYearScroller();
          }

          break;
      }
    }
  }, {
    key: "_toggleAnimateClass",
    value: function _toggleAnimateClass(enable) {
      if (enable) {
        this.classList.add('animate');
      } else {
        this.classList.remove('animate');
      }
    }
  }, {
    key: "_toggleYearScroller",
    value: function _toggleYearScroller() {
      this._isYearScrollerVisible() ? this._closeYearScroller() : this._openYearScroller();
    }
  }, {
    key: "_openYearScroller",
    value: function _openYearScroller() {
      this._translateX = 0;
      this.setAttribute('years-visible', '');
    }
  }, {
    key: "_closeYearScroller",
    value: function _closeYearScroller() {
      this.removeAttribute('years-visible');
      this._translateX = this._yearScrollerWidth;
    }
  }, {
    key: "_isYearScrollerVisible",
    value: function _isYearScrollerVisible() {
      return this._translateX < this._yearScrollerWidth / 2;
    }
  }, {
    key: "_translateXChanged",
    value: function _translateXChanged(x) {
      if (!this._desktopMode) {
        this.$.monthScroller.style.transform = 'translateX(' + (x - this._yearScrollerWidth) + 'px)';
        this.$.yearScroller.style.transform = 'translateX(' + x + 'px)';
      }
    }
  }, {
    key: "_yearAfterXYears",
    value: function _yearAfterXYears(index) {
      var result = new Date(this._originDate);
      result.setFullYear(parseInt(index) + this._originDate.getFullYear());
      return result.getFullYear();
    }
  }, {
    key: "_yearAfterXMonths",
    value: function _yearAfterXMonths(months) {
      return this._dateAfterXMonths(months).getFullYear();
    }
  }, {
    key: "_dateAfterXMonths",
    value: function _dateAfterXMonths(months) {
      var result = new Date(this._originDate);
      result.setDate(1);
      result.setMonth(parseInt(months) + this._originDate.getMonth());
      return result;
    }
  }, {
    key: "_differenceInMonths",
    value: function _differenceInMonths(date1, date2) {
      var months = (date1.getFullYear() - date2.getFullYear()) * 12;
      return months - date2.getMonth() + date1.getMonth();
    }
  }, {
    key: "_differenceInYears",
    value: function _differenceInYears(date1, date2) {
      return this._differenceInMonths(date1, date2) / 12;
    }
  }, {
    key: "_clear",
    value: function _clear() {
      this.selectedDate = '';
    }
  }, {
    key: "_close",
    value: function _close() {
      var overlayContent = this.getRootNode().host;
      var overlay = overlayContent ? overlayContent.getRootNode().host : null;

      if (overlay) {
        overlay.opened = false;
      }

      this.dispatchEvent(new CustomEvent('close', {
        bubbles: true,
        composed: true
      }));
    }
  }, {
    key: "_cancel",
    value: function _cancel() {
      this.focusedDate = this.selectedDate;

      this._close();
    }
  }, {
    key: "_preventDefault",
    value: function _preventDefault(e) {
      e.preventDefault();
    }
    /**
     * Keyboard Navigation
     */

  }, {
    key: "_eventKey",
    value: function _eventKey(e) {
      var keys = ['down', 'up', 'right', 'left', 'enter', 'space', 'home', 'end', 'pageup', 'pagedown', 'tab', 'esc'];

      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];

        if (IronA11yKeysBehavior.keyboardEventMatchesKeys(e, k)) {
          return k;
        }
      }
    }
  }, {
    key: "_onKeydown",
    value: function _onKeydown(e) {
      var _this4 = this;

      var focus = this._currentlyFocusedDate(); // Cannot use (today/cancel).focused flag because vaadin-text-field removes it
      // previously in the keydown event.


      var isToday = e.composedPath().indexOf(this.$.todayButton) >= 0;
      var isCancel = e.composedPath().indexOf(this.$.cancelButton) >= 0;
      var isScroller = !isToday && !isCancel;

      var eventKey = this._eventKey(e);

      if (eventKey === 'tab') {
        // We handle tabs here and don't want to bubble up.
        e.stopPropagation();
        var isFullscreen = this.hasAttribute('fullscreen');
        var isShift = e.shiftKey;

        if (isFullscreen) {
          e.preventDefault();
        } else if (isShift && isScroller || !isShift && isCancel) {
          // Return focus back to the input field
          e.preventDefault();
          this.dispatchEvent(new CustomEvent('focus-input', {
            bubbles: true,
            composed: true
          }));
        } else if (isShift && isToday) {
          // Browser returns focus back to the scrollable area. We need to set
          // the focused flag, and move the scroll to focused date.
          this._focused = true;
          setTimeout(function () {
            return _this4.revealDate(_this4.focusedDate);
          }, 1);
        } else {
          // Browser moves the focus out of the scroller, hence focused flag must
          // set to false.
          this._focused = false;
        }
      } else if (eventKey) {
        e.preventDefault();
        e.stopPropagation();

        switch (eventKey) {
          case 'down':
            this._moveFocusByDays(7);

            this.focus();
            break;

          case 'up':
            this._moveFocusByDays(-7);

            this.focus();
            break;

          case 'right':
            if (isScroller) {
              this._moveFocusByDays(1);
            }

            break;

          case 'left':
            if (isScroller) {
              this._moveFocusByDays(-1);
            }

            break;

          case 'enter':
            if (isScroller || isCancel) {
              this._close();
            } else if (isToday) {
              this._onTodayTap();
            }

            break;

          case 'space':
            if (isCancel) {
              this._close();
            } else if (isToday) {
              this._onTodayTap();
            } else {
              var focusedDate = this.focusedDate;

              if (DatePickerHelper._dateEquals(focusedDate, this.selectedDate)) {
                this.selectedDate = '';
                this.focusedDate = focusedDate;
              } else {
                this.selectedDate = focusedDate;
              }
            }

            break;

          case 'home':
            this._moveFocusInsideMonth(focus, 'minDate');

            break;

          case 'end':
            this._moveFocusInsideMonth(focus, 'maxDate');

            break;

          case 'pagedown':
            this._moveFocusByMonths(e.shiftKey ? 12 : 1);

            break;

          case 'pageup':
            this._moveFocusByMonths(e.shiftKey ? -12 : -1);

            break;

          case 'esc':
            this._cancel();

            break;
        }
      }
    }
  }, {
    key: "_currentlyFocusedDate",
    value: function _currentlyFocusedDate() {
      return this.focusedDate || this.selectedDate || this.initialPosition || new Date();
    }
  }, {
    key: "_focusDate",
    value: function _focusDate(dateToFocus) {
      this.focusedDate = dateToFocus;
      this._focusedMonthDate = dateToFocus.getDate();
    }
  }, {
    key: "_focusClosestDate",
    value: function _focusClosestDate(focus) {
      this._focusDate(DatePickerHelper._getClosestDate(focus, [this.minDate, this.maxDate]));
    }
  }, {
    key: "_moveFocusByDays",
    value: function _moveFocusByDays(days) {
      var focus = this._currentlyFocusedDate();

      var dateToFocus = new Date(0, 0);
      dateToFocus.setFullYear(focus.getFullYear());
      dateToFocus.setMonth(focus.getMonth());
      dateToFocus.setDate(focus.getDate() + days);

      if (this._dateAllowed(dateToFocus, this.minDate, this.maxDate)) {
        this._focusDate(dateToFocus);
      } else {
        if (this._dateAllowed(focus, this.minDate, this.maxDate)) {
          // Move to min or max date
          if (days > 0) {
            // down or right
            this._focusDate(this.maxDate);
          } else {
            // up or left
            this._focusDate(this.minDate);
          }
        } else {
          // Move to closest allowed date
          this._focusClosestDate(focus);
        }
      }
    }
  }, {
    key: "_moveFocusByMonths",
    value: function _moveFocusByMonths(months) {
      var focus = this._currentlyFocusedDate();

      var dateToFocus = new Date(0, 0);
      dateToFocus.setFullYear(focus.getFullYear());
      dateToFocus.setMonth(focus.getMonth() + months);
      var targetMonth = dateToFocus.getMonth();
      dateToFocus.setDate(this._focusedMonthDate || (this._focusedMonthDate = focus.getDate()));

      if (dateToFocus.getMonth() !== targetMonth) {
        dateToFocus.setDate(0);
      }

      if (this._dateAllowed(dateToFocus, this.minDate, this.maxDate)) {
        this.focusedDate = dateToFocus;
      } else {
        if (this._dateAllowed(focus, this.minDate, this.maxDate)) {
          // Move to min or max date
          if (months > 0) {
            // pagedown
            this._focusDate(this.maxDate);
          } else {
            // pageup
            this._focusDate(this.minDate);
          }
        } else {
          // Move to closest allowed date
          this._focusClosestDate(focus);
        }
      }
    }
  }, {
    key: "_moveFocusInsideMonth",
    value: function _moveFocusInsideMonth(focusedDate, property) {
      var dateToFocus = new Date(0, 0);
      dateToFocus.setFullYear(focusedDate.getFullYear());

      if (property === 'minDate') {
        dateToFocus.setMonth(focusedDate.getMonth());
        dateToFocus.setDate(1);
      } else {
        dateToFocus.setMonth(focusedDate.getMonth() + 1);
        dateToFocus.setDate(0);
      }

      if (this._dateAllowed(dateToFocus, this.minDate, this.maxDate)) {
        this._focusDate(dateToFocus);
      } else {
        if (this._dateAllowed(focusedDate, this.minDate, this.maxDate)) {
          // Move to minDate or maxDate
          this._focusDate(this[property]);
        } else {
          // Move to closest allowed date
          this._focusClosestDate(focusedDate);
        }
      }
    }
  }, {
    key: "_dateAllowed",
    value: function _dateAllowed(date, min, max) {
      return (!min || date >= min) && (!max || date <= max);
    }
  }, {
    key: "_isTodayAllowed",
    value: function _isTodayAllowed(min, max) {
      var today = new Date();
      var todayMidnight = new Date(0, 0);
      todayMidnight.setFullYear(today.getFullYear());
      todayMidnight.setMonth(today.getMonth());
      todayMidnight.setDate(today.getDate());
      return this._dateAllowed(todayMidnight, min, max);
    }
  }, {
    key: "_stopPropagation",
    value: function _stopPropagation(e) {
      e.stopPropagation();
    }
  }], [{
    key: "template",
    get: function get() {
      return html(_templateObject());
    }
  }, {
    key: "is",
    get: function get() {
      return 'vaadin-date-picker-overlay-content';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        /**
         * The value for this element.
         */
        selectedDate: {
          type: Date,
          notify: true
        },

        /**
         * Date value which is focused using keyboard.
         */
        focusedDate: {
          type: Date,
          notify: true,
          observer: '_focusedDateChanged'
        },
        _focusedMonthDate: Number,

        /**
         * Date which should be visible when there is no value selected.
         */
        initialPosition: {
          type: Date,
          observer: '_initialPositionChanged'
        },
        _originDate: {
          value: new Date()
        },
        _visibleMonthIndex: Number,
        _desktopMode: Boolean,
        _translateX: {
          observer: '_translateXChanged'
        },
        _yearScrollerWidth: {
          value: 50
        },
        i18n: {
          type: Object
        },
        showWeekNumbers: {
          type: Boolean
        },
        _ignoreTaps: Boolean,
        _notTapping: Boolean,

        /**
         * The earliest date that can be selected. All earlier dates will be disabled.
         */
        minDate: Date,

        /**
         * The latest date that can be selected. All later dates will be disabled.
         */
        maxDate: Date,
        _focused: Boolean,

        /**
         * Input label
         */
        label: String
      };
    }
  }]);

  return DatePickerOverlayContentElement;
}(ThemableMixin(ThemePropertyMixin(GestureEventListeners(PolymerElement))));

customElements.define(DatePickerOverlayContentElement.is, DatePickerOverlayContentElement);